const ExportIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em"
         height="1em"
         fill="currentColor">
        <path
            d="M10.7482 13.1613C10.7482 13.6612 10.343 14.0664 9.84324 14.0664C9.34344 14.0664 8.93827 13.6612 8.93827 13.1613V5.08979L6.86326 7.1648C6.50984 7.51822 5.93683 7.51822 5.58342 7.1648C5.23001 6.81139 5.23001 6.23839 5.58342 5.88497L9.20333 2.26506C9.55675 1.91165 10.1297 1.91165 10.4832 2.26506L14.1031 5.88497C14.4565 6.23839 14.4565 6.81139 14.1031 7.1648C13.7496 7.51822 13.1766 7.51822 12.8233 7.1648L10.7482 5.08979V13.1613Z"
            fill="currentColor"
        />
        <path
            d="M17.6862 14.3681C17.6862 13.8682 17.2811 13.463 16.7813 13.463C16.2814 13.463 15.8763 13.8682 15.8763 14.3681V15.2851C15.8763 15.7848 15.4712 16.19 14.9713 16.19H4.71493C4.21512 16.19 3.80996 15.7848 3.80996 15.2851V14.3681C3.80996 13.8682 3.40478 13.463 2.90497 13.463C2.40518 13.463 2 13.8682 2 14.3681V15.2851C2 16.7845 3.21552 18 4.71493 18H14.9713C16.4707 18 17.6862 16.7845 17.6862 15.2851V14.3681Z"
            fill="currentColor"
        />
    </svg>
);

export default ExportIcon;
